import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { environmentEntityContent } from './EnvironmentEntityContent';
import { secretEntityContent } from './SecretEntityContent';
import { resourceEntityContent } from './ResourceEntityContent';

export const configurationModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    environmentEntityContent,
    secretEntityContent,
    resourceEntityContent,
  ],
});
